import {types} from './types';

const initialState = {
    list: [],
    dayli: {
        data: [],
        countPage: 1
    },
    shift: {
        data: [],
        countPage: 0
    },
    view: {},
    gamer_information: {
        count_gamer: 0,
    },
    detalization: {
        count: 0,
        sumDeposit: 0,
        sumWithdrawal: 0
    },
    bet: {
        sumBet: 0,
        countBet: 0,
        sumWin: 0
    },
}

export function cashiersMobileReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GROUPS:
            return { ...state, list: action.payload};
        case types.SET_DAYLI:
            return { ...state, dayli: action.payload};
        case types.SET_SHIFT:
            return { ...state, shift: action.payload};
        case types.SET_GROUPS_VIEW:
            return { ...state, view: action.payload};
        case types.SET_COUNT_GAMER:
            return { ...state, gamer_information: action.payload};
        case types.SET_OPERATOR_DETALIZATION:
            return { ...state, detalization: action.payload};
        case types.SET_BET:
            return { ...state, bet: action.payload};
        default:
            return state
    }
}